export default "__VITE_ASSET__ReYy5WI___"